import React, { Component } from 'react'
import { Collapse } from 'antd'
import {connectSearchBox} from 'react-instantsearch/connectors';
import { Configure, InstantSearch, Hits, PoweredBy, RefinementList, Pagination, CurrentRefinements, ClearRefinements } from 'react-instantsearch/dom';

const Panel = Collapse.Panel;

import Product from './Product'

const VirtualSearchBox = connectSearchBox(() => null);

class ProductSearch extends Component {

  constructor(props) {
    super(props);

    this.state = {
      searchState: null
    }
  }

  handleStateChange = (searchState) => {
    this.setState({searchState});
  };

  render() {
    const { searchQuery, productSearchConfig } = this.props;
    const { searchState } = this.state;

    return (
      <InstantSearch
        {...productSearchConfig}
        onSearchStateChange={ this.handleStateChange }
        searchState={{
          ...searchState,
          query: searchQuery
        }}
      >
        <VirtualSearchBox/>
        <Configure hitsPerPage={ 10 }/>
        <Collapse bordered={false}>
          <Panel header="Filter" key="1" >
            <CurrentRefinements/>
            <ClearRefinements/>
            <RefinementList attribute="state" />
          </Panel>
        </Collapse>
        <Hits hitComponent={Product} />
        <div className="search-pagination">
          <Pagination />
        </div>
        <PoweredBy />
      </InstantSearch>
    )
  }
}

export default ProductSearch